import React from 'react';
import { Box, Container, Divider, Stack, Typography } from '@mui/material';
import MainCard from 'components/MainCard';
import Logo from 'components/Logo';

// ==============================|| SHARED LAYOUT FOR STATIC/LEGAL PAGES ||==============================
// Used by TermsAndConditions, PrivacyPolicy, and Support so all three are
// visually identical to each other and inherit the app's actual theme
// (via MainCard + MUI's Typography variants / color="primary") rather than
// hardcoded colors that might not match your real palette.

export const LegalPageLayout = ({ title, lastUpdated, children }) => (
  <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
      <Logo />
    </Box>
    <MainCard elevation={0} border content={false} sx={{ borderRadius: 3 }}>
      <Box sx={{ p: { xs: 3, md: 5 } }}>
        <Stack spacing={0.5} sx={{ mb: 3 }}>
          <Typography variant="h3">{title}</Typography>
          {lastUpdated && (
            <Typography variant="body2" color="text.secondary">
              Last updated: {lastUpdated}
            </Typography>
          )}
        </Stack>
        <Divider sx={{ mb: 3 }} />
        {children}
      </Box>
    </MainCard>
  </Container>
);

// Consistent heading + body block used throughout the legal pages.
export const LegalSection = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.75 }}>
      {children}
    </Typography>
  </Box>
);

export default LegalPageLayout;
